const MAX_IMAGE_CONTAINER_WIDTH = 1000;
export const SRC_SET_WIDTHS = [MAX_IMAGE_CONTAINER_WIDTH, MAX_IMAGE_CONTAINER_WIDTH * 2];
export const SIZES = `${MAX_IMAGE_CONTAINER_WIDTH}px`;

export const THUMBS_VISIBLE = 7;
const THUMB_SIZE_PX = 90;
export const THUMB_SRC_WIDTH = 200;
const CAROUSEL_VH_RATIO = 0.7;
const CAROUSEL_MIN_HEIGHT_PX = 520;
const CAROUSEL_MAX_HEIGHT_PX = 620;
const THUMB_GAP = 9;

function getCarouselHeightPx(): number {
    if (typeof window === 'undefined') {
        return CAROUSEL_MAX_HEIGHT_PX;
    }

    return Math.min(
        Math.max(window.innerHeight * CAROUSEL_VH_RATIO, CAROUSEL_MIN_HEIGHT_PX),
        CAROUSEL_MAX_HEIGHT_PX
    );
}

export function computeThumbMetrics(): {
    thumbSize: number;
    thumbItemHeight: number;
    pageHeight: number;
} {
    const pageHeight = getCarouselHeightPx();

    return {
        thumbSize: THUMB_SIZE_PX,
        thumbItemHeight: THUMB_SIZE_PX + THUMB_GAP,
        pageHeight,
    };
}
